// src/services/whatsappService.js
import supabase from "../supabaseClient";

export const sendTherapistWhatsAppNotification = async (therapistId, clientName, sessionDetails) => {
  try {
    // Get therapist phone number and WhatsApp preference
    const { data: therapist, error: therapistError } = await supabase
      .from('therapists')
      .select('name, whatsapp_number, notification_preferences')
      .eq('id', therapistId)
      .single();

    if (therapistError) throw therapistError;

    // Check if therapist wants WhatsApp notifications
    if (!therapist.whatsapp_number || 
        therapist.notification_preferences?.whatsapp === false) {
      console.log('Therapist does not have WhatsApp notifications enabled');
      return { success: false, reason: 'WhatsApp not enabled' };
    }

    // Format message
    const message = `🏥 New Client Scheduled!\n\nClient: ${clientName}\nDay: ${sessionDetails.day}\nTime: ${sessionDetails.time}\nType: ${sessionDetails.sessionType}\nStart Date: ${sessionDetails.startDate}\n\nThe complete demographics are available in the client's tab in your dashboard.\n\nThe relevant documents (if available) will also be available in your dashboard before the session.\n\nPlease do not reply to this automated message. Thank you`;

    // For now, let's use a direct Twilio API call
    // Note: This exposes credentials client-side - we'll improve this later
    const response = await fetch(
      `https://api.twilio.com/2010-04-01/Accounts/${process.env.REACT_APP_TWILIO_ACCOUNT_SID}/Messages.json`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Basic ${btoa(`${process.env.REACT_APP_TWILIO_ACCOUNT_SID}:${process.env.REACT_APP_TWILIO_AUTH_TOKEN}`)}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          From: process.env.REACT_APP_TWILIO_WHATSAPP_NUMBER,
          To: `whatsapp:${therapist.whatsapp_number}`,
          Body: message,
        }),
      }
    );

    const data = await response.json();

    if (response.ok) {
      return { success: true, data };
    } else {
      throw new Error(data.message || 'Failed to send WhatsApp message');
    }

  } catch (error) {
    console.error('Error sending WhatsApp notification:', error);
    return { success: false, error: error.message };
  }
};